const selectors = {
  flickitySlider: '.flickity-enabled',
  flickityButton: 'button.flickity-button',
};
// add verbosity to image gallery carousel arrow CTAs
(function changeFlickityAriaLabels(attempts = 0) {
  const flickitySliders = document.querySelectorAll(selectors.flickitySlider);
  // retry if slider not initialized
  if (!flickitySliders.length && attempts <= 10) {
    return setTimeout(() => {
      changeFlickityAriaLabels(attempts + 1);
    }, 100);
  }

  return flickitySliders.forEach((slider) => {
    const flickityButtons = slider.querySelectorAll(selectors.flickityButton);
    if (!flickityButtons.length) return false;
    if (slider.classList.contains('product-gallery__main')) {
      flickityButtons[0].ariaLabel = 'Previous image';
      flickityButtons[1].ariaLabel = 'Next image';
      return true;
    }
    if (slider.classList.contains('product-gallery__thumbnails')) {
      flickityButtons[0].ariaLabel = 'Previous thumbnail';
      flickityButtons[1].ariaLabel = 'Next thumbnail';
      return true;
    }
    if (slider.classList.contains('related-products-flickity')) {
      flickityButtons[0].ariaLabel = 'Previous product';
      flickityButtons[1].ariaLabel = 'Next product';
      return true;
    }
    return false;
  });
})();
